import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { QUOTE_CREATE } from '../apollo/quote/quoteMutation';
import { toast } from 'react-toastify'; //? React-Toastify
import Spinners from './spinner/Spinners';
import { useParams } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
// import { USERS, USER } from '../apollo/user/userQuery';

export default function AddQuote() {
  //! getting query
  const { userId } = useParams();
  // const navigate = useNavigate();

  const [quote, setQuote] = useState('');

  const handleChange = (e) => {
    setQuote(e.target.value);
  };

  /**
   *! Apollo-Client Implementation
   */
  const [QuoteCreate, { loading }] = useMutation(QUOTE_CREATE, {
    onError: (error) => {
      toast.error(error?.message);
    },
    onCompleted: ({ quoteCreate }) => {
      if (quoteCreate?.status === 201) {
        toast.success(quoteCreate?.message);
        //! store token in LocalStorage
        localStorage.setItem('token', quoteCreate?.token);

        // navigate('/');
      }
    },
    refetchQueries: ['users', 'user'],
    // update(cache, { data }) {
    //   const newData = data?.quoteCreate?.payload;

    //   const existinhUsersData = cache.readQuery({
    //     query: USERS,
    //   });
    //   if (existinhUsersData && newData) {
    //     cache.writeQuery({
    //       query: USERS,
    //       data: {
    //         user: [...existinhUsersData?.users?.payload, newData],
    //       },
    //     });
    //   }

    //   const existingData = cache.readQuery({
    //     query: USER,
    //   });
    //   if (existingData && newData) {
    //     cache.writeQuery({
    //       query: USER,
    //       data: {
    //         user: [...existingData?.user?.payload, newData],
    //       },
    //     });
    //   }
    // },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!quote) return;

    QuoteCreate({
      variables: {
        userId,
        quote,
      },
    });

    //! clearing
    setQuote('');
  };

  if (loading) return <Spinners />;
  //? #############################################################################
  return (
    <div className='container ' style={{ marginTop: '15rem' }}>
      <div className='card text-center'>
        <div className='card-body'>
          <h3 className='card-title text-light'>
            <u>Add New Quote</u>
          </h3>{' '}
          <br />
          <input
            type='text'
            value={quote}
            onChange={handleChange}
            placeholder='write your quote here !'
            className='form-control addQuote'
          />{' '}
          <br />
          <button
            type='submit'
            className='btn btn-lg btn-outline-info text-white mb-2 mx-5 my-2'
            onClick={handleSubmit}
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
}
